import HtmlToReactParser from 'html-to-react'

// eslint-disable-next-line @typescript-eslint/naming-convention
const Parser = new HtmlToReactParser.Parser()
const processNodeDefinitions = new HtmlToReactParser.ProcessNodeDefinitions()

const isValidNode = () => true

export { Parser, isValidNode, processNodeDefinitions }
